//file:testRunStatusAction.js
//import dependencies
import {testRunStatusAction} from './../constants';
export const addTestRunStatusFromAPI = ( totalData ) => {
    return {
        type:testRunStatusAction().addTestRunStatus,
        testRunStatus: totalData.data,
        pages: totalData.pages,
        currentPage: totalData.current_page
    }
}
